var _path, _path2, _g, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_38247)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_38247",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 185,
    height: 185
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185 0H0V185H185V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_38247)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_443_38247",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 181,
    height: 181
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22021 2.22021H182.78V182.78H2.22021V2.22021Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_443_38247)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1873 125.183L28.0609 121.702L31.5421 124.575L28.6685 128.057L25.1873 125.183Z",
    fill: "#00CF5D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.4303 46.6147L92.1002 42.7486L95.9663 40.4185L98.2964 44.2847L94.4303 46.6147Z",
    fill: "#00CF5D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.1847 154.13L90.8546 150.264L94.7207 147.934L97.0508 151.8L93.1847 154.13Z",
    fill: "#00CF5D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4664 123.411L60.1363 119.545L64.0024 117.215L66.3325 121.081L62.4664 123.411Z",
    fill: "#008540"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.922 81.4844L116.592 77.6182L120.458 75.2882L122.788 79.1543L118.922 81.4844Z",
    fill: "#008540"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2639 80.3505L52.1375 76.8693L55.6187 79.7429L52.7451 83.2241L49.2639 80.3505Z",
    fill: "#008540"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6158 161.187L66.3629 154.225L73.3253 159.972L67.5781 166.934L60.6158 161.187Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6603 55.3926L45.0002 47.6603L52.7324 43.0002L57.3926 50.7324L49.6603 55.3926Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.137 129L140.477 121.268L148.209 116.608L152.869 124.34L145.137 129Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8337 49.7345L20.6912 43.8492L15.1954 41.4538L20.4396 38.5486L21.0194 32.5815L25.403 36.6713L31.2572 35.3788L28.7221 40.8117L31.7604 45.9799L25.8101 45.2478L21.8337 49.7345Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.61 171.599L128.869 167.93L123.159 169.756L125.183 164.113L121.682 159.247L127.674 159.428L131.221 154.594L132.9 160.349L138.593 162.229L133.638 165.604L133.61 171.599Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.632 62.4101L151.732 63.4734L149.263 68.9367L146.428 63.6539L140.469 62.994L144.618 58.6658L143.404 52.7947L148.802 55.4025L154.011 52.4338L153.199 58.3738L157.632 62.4101Z",
    fill: "#64FF32"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_443_38247",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 181,
    height: 181
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.78 2.22021V182.78H2.22028V2.22021H182.78Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_443_38247)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9228 30.2206L65.358 34.5003L61.0783 35.9355L59.6431 31.6558L63.9228 30.2206Z",
    fill: "#00CF5D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.884 96.0883L136.797 91.9998L140.885 93.913L138.972 98.0015L134.884 96.0883Z",
    fill: "#00CF5D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2694 94.9345L37.1826 90.846L41.2711 92.7591L39.3579 96.8477L35.2694 94.9345Z",
    fill: "#00CF5D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7303 66.473L65.6435 62.3845L69.732 64.2977L67.8188 68.3862L63.7303 66.473Z",
    fill: "#008540"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.576 118.78L104.489 114.692L108.578 116.605L106.665 120.693L102.576 118.78Z",
    fill: "#008540"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.461 52.5282L106.896 56.808L102.616 58.2431L101.181 53.9634L105.461 52.5282Z",
    fill: "#008540"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2685 63.1321L35.1389 71.6916L26.5794 74.562L23.709 66.0024L32.2685 63.1321Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154 71.1775L157.827 63.0005L166.004 66.8269L162.177 75.0039L154 71.1775Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0002 156.178L39.8266 148.001L48.0036 151.827L44.1772 160.004L36.0002 156.178Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.832 31.2014L129.199 33.8718L134.442 30.9639L133.561 36.894L137.947 40.9816L132.035 41.9763L129.502 47.4104L126.729 42.095L120.779 41.3658L124.977 37.0861L123.832 31.2014Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3551 134.819L22.6409 128.831L17.8699 125.201L23.6535 123.622L25.6318 117.963L28.9204 122.975L34.9141 123.108L31.1631 127.785L32.8891 133.526L27.2821 131.404L22.3551 134.819Z",
    fill: "#64FF32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.789 161.374L158.409 156.422L152.414 156.4L156.078 151.655L154.247 145.946L159.892 147.965L164.756 144.46L164.58 150.453L169.417 153.995L163.663 155.679L161.789 161.374Z",
    fill: "#64FF32"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_38247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.dcbe9010d87f34a65829d7e1fa2991e9.svg";
export { ForwardRef as ReactComponent };